/**
 * Compute total work hours from check_in and check_out (HH:MM strings) and a status.
 *
 * Returns the canonical string for display:
 *   "—"        — no check-in OR status is Leave/Absent/Holiday with no times recorded
 *   "0 hrs"    — Leave / Absent / Holiday (per requirement)
 *   "X hrs Y min" — normal computed duration
 *
 * Safe on legacy "00:00" placeholders (treated as not-set).
 */
export function computeWorkHours(check_in, check_out, status) {
  const NON_WORK_STATUSES = ["Leave", "Absent", "Holiday"];
  if (NON_WORK_STATUSES.includes(status)) return "0 hrs";

  const normalize = (v) => (v && v !== "00:00" ? v : null);
  const ci = normalize(check_in);
  const co = normalize(check_out);
  if (!ci || !co) return "—";

  const [ih, im] = ci.split(":").map(Number);
  const [oh, om] = co.split(":").map(Number);
  if (Number.isNaN(ih) || Number.isNaN(oh)) return "—";

  let mins = oh * 60 + om - (ih * 60 + im);
  if (mins < 0) mins += 24 * 60; // overnight rollover, defensive

  const hrs = Math.floor(mins / 60);
  const rem = mins % 60;
  if (hrs === 0 && rem === 0) return "0 hrs";
  if (hrs === 0) return `${rem} min`;
  if (rem === 0) return `${hrs} hrs`;
  return `${hrs} hrs ${rem} min`;
}
